import { axiosJSONInstance } from '@/config';
import { MerchantPricingPlan } from '@/types';

/**
 * GET /v1/merchants/pricing-plan — the merchant's own tier standing.
 *
 * The endpoint answers 200 with a NULL object when the merchant has no
 * granting assignment, which is every merchant today. That is a real,
 * successful answer ("you are on standard pricing"), not a miss, so it is
 * normalised to null here and rendered as a deliberate empty state — never as
 * an error.
 */
export const fetchMerchantPricingPlan = async (): Promise<MerchantPricingPlan | null> => {
  const response = await axiosJSONInstance.get('/merchants/pricing-plan');
  return response.data?.object ?? null;
};
